export default "/images/polling.png?57235852f139d027641ebc51082e85ec";